import { Currency, DateFormat, Languages } from '@dark-portal/backend-planora';
import i18n from 'i18next';
import { create } from 'zustand';

import { getDefaultCurrencyBasedOnLang } from '@/src/features/_infrastructure/currency/getDefaultCurrencyBasedOnLang';
import { getDefaultDateFormatBasedOnLang } from '@/src/features/_infrastructure/date/getDefaultDateFormatBasedOnLang';

export enum UserConfigurationStatus {
  Idle = 'Idle',
  Loading = 'Loading',
  Error = 'Error',
}

export interface User {
  username: string;
  discriminator: string;
  language: Languages;
  currency: Currency;
  dateFormat: DateFormat;
  contactLanguage: Languages;
  contactPhone: string | undefined;
  contactEmail: string | undefined;
}

export interface UserConfigurationState {
  user: User;
  status: UserConfigurationStatus;
  registered: boolean;
}

export interface UserConfigurationStore extends UserConfigurationState {
  updateRegistered(registered: boolean): void;
  updateStatus(status: UserConfigurationStatus): void;
  updateUser(user: Partial<User>): void;
}

export const userConfigurationStore = create<UserConfigurationStore>((set) => ({
  user: {
    username: '',
    discriminator: '',
    language: i18n.language as Languages,
    currency: getDefaultCurrencyBasedOnLang(),
    dateFormat: getDefaultDateFormatBasedOnLang(),
    contactLanguage: i18n.language as Languages,
    contactPhone: undefined,
    contactEmail: undefined,
  },
  status: UserConfigurationStatus.Loading,
  registered: false,
  updateRegistered: (registered: boolean) => set({ registered }),
  updateStatus: (status: UserConfigurationStatus) => set({ status }),
  updateUser: (user: Partial<User>) => {
    set((prev) => {
      if (user.language && prev.user.language !== user.language) {
        void i18n.changeLanguage(user.language);
      }

      return { user: { ...prev.user, ...user } };
    });
  },
}));
